var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#ECEEF2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5 12.25C24.7051 12.25 23.25 13.7051 23.25 15.5C23.25 15.6959 23.2673 15.8878 23.3006 16.0741L18.5699 19.3856C18.5459 19.4024 18.5231 19.4204 18.5017 19.4394C17.9499 19.0075 17.255 18.75 16.5 18.75C14.7051 18.75 13.25 20.2051 13.25 22C13.25 23.7949 14.7051 25.25 16.5 25.25C17.255 25.25 17.9499 24.9925 18.5017 24.5606C18.5231 24.5796 18.5459 24.5976 18.5699 24.6144L23.3006 27.9259C23.2673 28.1122 23.25 28.3041 23.25 28.5C23.25 30.2949 24.7051 31.75 26.5 31.75C28.2949 31.75 29.75 30.2949 29.75 28.5C29.75 26.7051 28.2949 25.25 26.5 25.25C25.4472 25.25 24.5113 25.7506 23.9174 26.5267L19.4381 23.3911C19.6381 22.9694 19.75 22.4978 19.75 22C19.75 21.5022 19.6381 21.0306 19.4381 20.6089L23.9174 17.4733C24.5113 18.2494 25.4472 18.75 26.5 18.75C28.2949 18.75 29.75 17.2949 29.75 15.5C29.75 13.7051 28.2949 12.25 26.5 12.25ZM24.75 15.5C24.75 14.5335 25.5335 13.75 26.5 13.75C27.4665 13.75 28.25 14.5335 28.25 15.5C28.25 16.4665 27.4665 17.25 26.5 17.25C25.5335 17.25 24.75 16.4665 24.75 15.5ZM16.5 20.25C15.5335 20.25 14.75 21.0335 14.75 22C14.75 22.9665 15.5335 23.75 16.5 23.75C17.4665 23.75 18.25 22.9665 18.25 22C18.25 21.0335 17.4665 20.25 16.5 20.25ZM26.5 26.75C25.5335 26.75 24.75 27.5335 24.75 28.5C24.75 29.4665 25.5335 30.25 26.5 30.25C27.4665 30.25 28.25 29.4665 28.25 28.5C28.25 27.5335 27.4665 26.75 26.5 26.75Z",
    fill: "#333B47"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.b847a526e5ba07da96effd0e6d8f8c7d.svg";
export { ForwardRef as ReactComponent };